import {Trash} from "react-feather";
import {useTheme} from "styled-components";
import {TableRow, TableCell, TableBody} from "@mui/material";
import {useAppDispatch, useAppSelector, useModal} from "hooks";
import {removeClientProduct} from "global/slices/clients/thunks";
import {Avatar, Confirm, IconButton, Row, Typography, Zoom} from "components";

interface BodyProps {}

export const Body: React.FC<BodyProps> = () => {
  const dispatch = useAppDispatch();
  const {openModal, closeModal} = useModal();
  const {white, blackWhite, heart} = useTheme();
  const {clientProducts} = useAppSelector("clients");

  return (
    <TableBody>
      {clientProducts.map((product, key) => {
        const {id, precio, nombre, en_existencia, imagenes} = product;

        return (
          <TableRow hover key={`${id}-${key}`} tabIndex={-1}>
            <TableCell padding="none" style={{maxWidth: 380}}>
              <Typography className="line-clamp-1">{nombre}</Typography>
            </TableCell>
            <TableCell>
              <Typography>Bs. {precio.toLocaleString("US")}</Typography>
            </TableCell>
            <TableCell>
              <Typography className="line-clamp-1">{en_existencia}</Typography>
            </TableCell>
            <TableCell>
              <Row>
                {!imagenes["length"] ? (
                  <Typography fontStyle="italic">No hay archivos</Typography>
                ) : (
                  imagenes.map(({imagen}, key) => (
                    <Zoom key={key}>
                      <Avatar size={25} borderRadius={100} src={imagen} />
                    </Zoom>
                  ))
                )}
              </Row>
            </TableCell>
            <TableCell>
              <IconButton
                toolTip="Eliminar"
                icon={<Trash color={heart} />}
                onClick={() =>
                  openModal(
                    <Confirm
                      title={`Eliminar Producto: ${nombre}`}
                      message="Presiona Eliminar para continuar. Una vez eliminado no se podrá recuperar esta información"
                      actions={[
                        {
                          label: "Eliminar",
                          style: {backgroundColor: heart},
                          loaderId: "remove-client-product",
                          typographyProps: {color: white},
                          onClick: () => dispatch(removeClientProduct(id)),
                        },
                        {
                          label: "Cancelar",
                          onClick: () => closeModal(),
                          typographyProps: {color: blackWhite},
                          style: {backgroundColor: "transparent"},
                        },
                      ]}
                    />
                  )
                }
              />
            </TableCell>
          </TableRow>
        );
      })}
    </TableBody>
  );
};
